import { Box } from '@mui/material';

const AUDIT_TYPE_STYLES = {
  insert: { color: '#166534', backgroundColor: '#dcfce7', borderColor: '#86efac' },
  update: { color: '#1d4ed8', backgroundColor: '#dbeafe', borderColor: '#93c5fd' },
};

function AuditTypeBadge({ auditType }) {
  const style = AUDIT_TYPE_STYLES[auditType?.toLowerCase()] ?? {};

  return (
    <Box
      component="span"
      sx={{
        px: 1,
        py: 0.25,
        borderRadius: 10,
        border: '1px solid',
        fontSize: 11,
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: 0.4,
        ...style,
      }}
    >
      {auditType}
    </Box>
  );
}

export default AuditTypeBadge;
